import styled from 'styled-components';

import { colors, mediaRetina } from 'theme';

import { ButtonWithStyles } from './ButtonWithStyles';

export const LegacySecondaryButtonDanger = styled(ButtonWithStyles)`
  color: ${colors.scarlet};
  background-color: ${colors.white};
  box-shadow: inset 0 0 0 1px ${colors.scarlet};
  ${mediaRetina} {
    box-shadow: inset 0 0 0 1.5px ${colors.scarlet};
  }
`;
